module.exports = __webpack_public_path__ + "img/resultCircleSide.f09c92f4.png";